import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { addToast } from "@app/components/toast/toast.service";
import { RoutePath } from "@app/constants";
import BookTimeFrameService from "@app/services/http/book-time-frame.service";
import { BookTimeFrameCreate } from "@app/types/book-time-frame.type";
import { createBookTimeFrameValidationSchema } from "@app/validations";
import { Form, Formik, FormikContextType } from "formik";
import { createRef } from "react";
import { useNavigate } from "react-router-dom";

interface FormValues {
  startTime: string;
  endTime: string;
  bookIds: string;
}

const CreateBookTimePage = () => {
  const navigate = useNavigate();
  const formRef = createRef<FormikContextType<FormValues>>();

  const handleSubmit = async (values: FormValues) => {
    try {
      const bookTimeFrameData: BookTimeFrameCreate = {
        startTime: values.startTime,
        endTime: values.endTime,
        bookIds: values.bookIds.trim(),
      };

      await BookTimeFrameService.create(bookTimeFrameData);

      addToast({
        text: "Tạo khung giờ thành công!",
        status: "valid",
      });

      navigate(`/${RoutePath.BOOK_TIME_MANAGEMENT}`);
    } catch (error) {
      addToast({
        text: "Có lỗi xảy ra khi tạo khung giờ!",
        status: "inValid",
      });
    }
  };

  const handleCancel = () => {
    navigate(`/${RoutePath.BOOK_TIME_MANAGEMENT}`);
  };

  return (
    <div className="py-6 px-12">
      <div className="flex justify-between items-center">
        <div className="text-[#343C6A]">
          Danh sách cài đặt khung giờ / Tạo mới
        </div>
      </div>

      <Formik
        innerRef={formRef}
        initialValues={{
          startTime: "",
          endTime: "",
          bookIds: "",
        }}
        onSubmit={handleSubmit}
        validationSchema={createBookTimeFrameValidationSchema}
        validateOnChange
        validateOnBlur
      >
        <Form>
          <div className="mt-6 rounded-xl bg-white py-6 min-h-[60vh] px-5">
            <div className="w-[100%] max-w-[500px] space-y-6">
              <div className="flex gap-4">
                <div className="w-[48%]">
                  <FormControl name="startTime">
                    <Input
                      type="time"
                      className="mt-7"
                      placeholder="Khung giờ bắt đầu"
                    />
                  </FormControl>
                </div>
                <div className="w-[48%]">
                  <FormControl name="endTime">
                    <Input
                      type="time"
                      className="mt-7"
                      placeholder="Khung giờ kết thúc"
                    />
                  </FormControl>
                </div>
              </div>

              <FormControl name="bookIds">
                <Input className="mt-7" placeholder="ID Sách" />
              </FormControl>
            </div>
          </div>
          <div className="mt-8 flex gap-4">
            <Button
              type="submit"
              size="l"
              label="Tạo"
              width={160}
              className="!h-[51px] !leading-[51px]"
              labelClassName="text-xl"
            />
            <Button
              type="button"
              size="l"
              label="Hủy"
              theme="secondary"
              width={160}
              className="!h-[51px] !leading-[51px]"
              labelClassName="text-xl"
              onClick={handleCancel}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default CreateBookTimePage;
